export function number(number, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(number, decimal);
}

export function vnd(money, decimal) {
  decimal = typeof decimal === "undefined" ? 2 : decimal;
  return formatNumber(money, decimal) + " đ";
}

export function cn(money, decimal) {
  decimal = typeof decimal === "undefined" ? 2 : decimal;
  return formatNumber(money, decimal) + " ¥";
}

export function vnd2(money, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(money, decimal);
}

export function vnd3(money, decimal) {
  decimal = typeof decimal === "undefined" ? 2 : decimal;
  return formatNumber(money, decimal)  + " VNĐ";
}

/**
 * Format dữ liệu số sử dụng ký tự 'k', lấy 1 số sau dấu phẩy
 * Ví dụ: 5000 -> 5k, 5600 -> 5,6k, 12100 -> 12,1k
 *
 * @param money
 * @param decimal
 */
export function vnd4(number) {
  const formattedNumber = Number(number);

  const rs = (formattedNumber/1000) >= 1
      ? formattedNumber % 1000 ? `${(formattedNumber/1000).toFixed(1)}k` : `${(formattedNumber/1000).toFixed(0)}k`
      : formattedNumber;

  return String(rs).replace('.', ',');
}

export function gam(gam, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(gam, decimal) + " g";
}

export function cm(cm, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(cm, decimal) + " cm";
}

export function percent(percent, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(percent, decimal) + " %";
}

export function currency(value, decimal) {
  if (value) {
    let number = +value.replace(/[^\d.]/g, "");
    number = isNaN(number) ? 0 : number;
    decimal = typeof decimal === "undefined" ? 0 : decimal;
    return formatNumber(number, decimal);
  }
}

export function formatCurrency(number) {
  if(!number) {
    return 0;
  }
  // Add thousands separator
  const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Format the number as a currency string
  return `${formattedNumber}`;
}
export function formatCurrencyCN(number) {
  // Add thousands separator
  const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Format the number as a currency string
  return `${formattedNumber}`;
}
function formatNumber(number, places, thousand, decimal) {
  number = number || 0;
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  // thousand = thousand || ",";
  thousand = thousand || ",";
  decimal = decimal || ".";
  let negative = number < 0 ? "-" : "";
  let i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "";
  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  return (
    negative +
    (j ? i.substr(0, j) + thousand : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : "")
  );
}
